<template>
  <div id="app">
    <HeaderRegion />

    <router-view />

    <FooterRegion />

    <Enter />

    <!-- <Plug /> -->

    <Verification @getThanksText="getThanksText" @getErrorText="getErrorText" />

    <WeeklyPrizes />

    <MonthlyPrizes />

    <Login
      :authText="authText"
      :authPhone="authPhone"
      @getErrorText="getErrorText"
    />

    <EnterCode
      @getThanksText="getThanksText"
      @getThanksTitle="getThanksTitle"
      @getErrorText="getErrorText"
    />

    <PasswordChange
      @getThanksText="getThanksText"
      @getThanksTitle="getThanksTitle"
      @getErrorText="getErrorText"
    />

    <Success />

    <Thanks :thanksText="thanksText" :thanksTitle="thanksTitle" />

    <ThanksFeedback />

    <PromoEnd />

    <AgeRestriction :noBtn="noBtn" />

    <ResetPassword
      @getThanksText="getThanksText"
      @getThanksTitle="getThanksTitle"
      @getErrorText="getErrorText"
    />

    <Error :errorText="errorText" />

    <ErrorAge />

<!--    <Registration-->
<!--      @getThanksText="getThanksText"-->
<!--      @getErrorText="getErrorText"-->
<!--      @getAuthText="getAuthText"-->
<!--    />-->
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
import Plug from "@/components/modals/Plug.vue";
import Error from "@/components/modals/Error.vue";
import Enter from "@/components/modals/Enter.vue";
import Login from "@/components/modals/Login.vue";
import PromoEnd from "@/components/modals/PromoEnd.vue";
import Thanks from "@/components/modals/Thanks.vue";
import ErrorAge from "@/components/modals/ErrorAge.vue";
import HeaderRegion from "@/components/HeaderRegion.vue";
import FooterRegion from "@/components/FooterRegion.vue";
import EnterCode from "@/components/modals/EnterCode.vue";
import Success from "@/components/modals/SuccessfullReg.vue";
import WeeklyPrizes from "@/components/modals/WeeklyPrizes.vue";
import Verification from "@/components/modals/Verification.vue";
import Registration from "@/components/modals/Registration.vue";
import ResetPassword from "@/components/modals/ResetPassword.vue";
import MonthlyPrizes from "@/components/modals/MonthlyPrizes.vue";
import AgeRestriction from "@/components/modals/AgeRestriction.vue";
import ThanksFeedback from "@/components/modals/ThanksFeedback.vue";
import PasswordChange from "@/components/modals/PasswordChange.vue";

export default {
  name: "App",

  components: {
    Plug,
    Error,
    Enter,
    Login,
    Thanks,
    Success,
    EnterCode,
    Verification,
    HeaderRegion,
    FooterRegion,
    WeeklyPrizes,
    Registration,
    ResetPassword,
    MonthlyPrizes,
    ThanksFeedback,
    AgeRestriction,
    PasswordChange,
    ErrorAge,
    PromoEnd
  },

  data() {
    return {
      noBtn: "",
      authText: "",
      authPhone: "",
      thanksText: "",
      thanksTitle: "",
      errorText: "",
      text: ""
    };
  },

  computed: {
    ...mapGetters({
      documents: "documents",
    }),
  },

  methods: {
    ...mapMutations({
      saveUser: "saveUser",
      setDocuments: "setDocuments",
      setRules: "setRules",
      setPrivacyPolicy: "setPrivacyPolicy",
      setUserAgreement: "setUserAgreement",
      setPersonalData: "setPersonalData",
    }),

    getThanksText(value) {
      this.thanksText = value;
    },

    getThanksTitle(value) {
      this.thanksTitle = value;
    },

    getErrorText(value) {
      this.errorText = value;
    },

    getAuthText(value) {
      this.authText = value;
    },

    showInfo(name) {
      if (name === "office") {
        this.thanksTitle = "Уважаемый участник!";
        this.thanksText =
          "Если у тебя уже есть принятый промокод, ожидай получение гарантированного приза в своем личном кабинете";
        this.$bvModal.show("thanks-modal");
      }
    },
  },

  mounted() {
    this.$bvModal.show("age-restriction-modal");
    if (this.documents === null) {
      axios
        .get("reference/documents", {
          headers: {
            Accept: "application/json",
          },
        })
        .then((response) => {
          this.setDocuments(response.data.data);
          const array = response.data.data;

          this.setRules(array.filter((data) => data.type == "rules")[0]);
          this.setPersonalData(
            array.filter((data) => data.type == "personal_data")[0],
          );
          this.setUserAgreement(
            array.filter((data) => data.type == "user_agreement")[0],
          );
          this.setPrivacyPolicy(
            array.filter((data) => data.type == "privacy_policy")[0],
          );
        });
    }

      this.thanksTitle = "Уважаемый участник!";
      this.thanksText =
          "Регистрация кодов завершена";
      this.$bvModal.show("thanks-modal");

    if (localStorage.getItem("token-bockarev")) {
      axios
        .get("user/account", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "access-control-allow-origin": "*",
            Authorization: "Bearer " + localStorage.getItem("token-bockarev"),
          },
        })
        .then((response) => {
          this.saveUser(response.data.data);
        })
        .catch((error) => {
          if (error.response.data.message) {
            localStorage.removeItem("token-bockarev");

            this.errorText = "Сессия истекла. Пожалуйста, авторизуйтесь";
            this.$bvModal.show("error-modal");

            if (window.location.pathname === "/office")
              window.location.href = "/";
          }
        });
    }

    // this.showInfo(this.$route.name);
  },
  watch: {
    // "$route.name": function (name) {
    //   this.showInfo(name);
    // },
  },
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  font-family: $regular;
  background-color: $dark-green;
  background-image: url("@/assets/app-bg.png");
  background-position: top center;
  background-size: cover;
}
</style>
